import { useState } from 'react';
export function useCollapsible() {
    const [expanded, setExpanded] = useState(new Set());
    const toggle = (key) => {
        setExpanded(prev => {
            const next = new Set(prev);
            if (next.has(key))
                next.delete(key);
            else
                next.add(key);
            return next;
        });
    };
    const reset = () => setExpanded(new Set());
    return [expanded, toggle, reset];
}
